import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";
import SummaryService from "../../../../../services/screens/admin/homework/management/SummaryService";
import { ActionTypes } from "../../../../actionTypes/screens/admin/homework/management/SummaryActionTypes";
import AsyncActionReducers from "../../../../AsyncActionReducers";
import _ from 'lodash';
import UIDs from "../../../../../UIDs";
import Constants from "../../../../../config/Constants";
const uid = UIDs.screens.admin.homework.management.summary;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            SummaryService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, vo) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        vo
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    loadUserHomeworkStatisticsAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_USERHOMEWORK_STATISTICS_ASYNC, searchVO });

            SummaryService.LoadUserHomeworkStatistics(
                searchVO,
                response => {
                    dispatch(Actions.loadUserHomeworkStatisticsSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadUserHomeworkStatisticsFailure(error));
                }
            );
        };
    },

    loadUserHomeworkStatisticsSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_USERHOMEWORK_STATISTICS_SUCCESS,
        parentType: ActionTypes.LOAD_USERHOMEWORK_STATISTICS_ASYNC,
        postReducer: loadUserHomeworkStatisticsSuccessPostReducer,
        data,
        searchVO
    }),

    loadUserHomeworkStatisticsFailure: error => ({
        type: ActionTypes.LOAD_USERHOMEWORK_STATISTICS_FAILURE,
        parentType: ActionTypes.LOAD_USERHOMEWORK_STATISTICS_ASYNC,
        error
    }),

    returnUserHomeworkAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.RETURN_USER_HOMEWORK_ASYNC, vo });

            SummaryService.returnUserHomework(
                vo,
                response => {
                    dispatch(Actions.returnUserHomeworkSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.returnUserHomeworkFailure(error));
                }
            );
        };
    },

    returnUserHomeworkSuccess: (data, vo) => ({
        type: ActionTypes.RETURN_USER_HOMEWORK_SUCCESS,
        parentType: ActionTypes.RETURN_USER_HOMEWORK_ASYNC,
        postReducer: returnUserHomeworkPostReducer,
        data,
        vo
    }),

    returnUserHomeworkFailure: error => ({
        type: ActionTypes.RETURN_USER_HOMEWORK_FAILURE,
        parentType: ActionTypes.RETURN_USER_HOMEWORK_ASYNC,
        error
    }),

    fixHomeworkAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.FIX_HOMEWORK_ASYNC, vo });

            SummaryService.fixHomework(
                vo,
                response => {
                    dispatch(Actions.fixHomeworkSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.fixHomeworkFailure(error));
                }
            );
        };
    },

    fixHomeworkSuccess: (data, vo) => ({
        type: ActionTypes.FIX_HOMEWORK_SUCCESS,
        parentType: ActionTypes.FIX_HOMEWORK_ASYNC,
        postReducer: fixHomeworkPostReducer,
        data,
        vo
    }),

    fixHomeworkFailure: error => ({
        type: ActionTypes.FIX_HOMEWORK_FAILURE,
        parentType: ActionTypes.FIX_HOMEWORK_ASYNC,
        error
    }),

    fixHomeworkZipAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.FIX_HOMEWORK_ZIP_ASYNC, vo });

            SummaryService.fixHomeworkZip(
                vo,
                response => {
                    dispatch(Actions.fixHomeworkZipSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.fixHomeworkZipFailure(error));
                }
            );
        };
    },

    fixHomeworkZipSuccess: (data, vo) => ({
        type: ActionTypes.FIX_HOMEWORK_ZIP_SUCCESS,
        parentType: ActionTypes.FIX_HOMEWORK_ZIP_ASYNC,
        postReducer: fixHomeworkZipPostReducer,
        data,
        vo
    }),

    fixHomeworkZipFailure: error => ({
        type: ActionTypes.FIX_HOMEWORK_ZIP_FAILURE,
        parentType: ActionTypes.FIX_HOMEWORK_ZIP_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {

    assignmentSummary: null,
    userHomeworks: null,
    unitData: null,
    unitType: null,
    cover: "",
    isSubjective: null,
    needRevise: 0,
    pageCount: 0,
    totalCount: 0,
    searchVO: {
        homeworkAssignmentId: "",
        homeworkUnitId: "",
        pageIndex: 1,
        pageSize: Constants.DefaultPageSize,
    },
    homeworkAssignmentMakeupOption: 1,
    discount:1,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, vo }) => {
    return {
        ...state,
        assignmentSummary: data.assignmentSummary,
        searchVO: {
            ...state.searchVO,
            homeworkAssignmentId: vo.homeworkAssignmentId,
            partnerId: vo.partnerId
        }
    };
};

const loadUserHomeworkStatisticsSuccessPostReducer = (state, { data, searchVO }) => {
    let { unitType, cover, unitData, isSubjective, needRevise } = state;
    if (searchVO.homeworkUnitId) {
        let unit = Array.from(state.assignmentSummary.units).find(u => u.id === searchVO.homeworkUnitId);
        unitType = unit.unitType;
        unitData = unit.data;
        cover = unit.cover;
        isSubjective = unit.isSubjective;
        needRevise = unit.needRevise;
    }
    return { ...state, ...data, unitData, unitType, cover, isSubjective, needRevise, searchVO };
};

const returnUserHomeworkPostReducer = (state, { data, vo }) => {
    var userHomeworks = _.clone(state.userHomeworks);
    if (userHomeworks) {
        let userHomework = userHomeworks.find(it => it.userHomeworkId === vo.userHomeworkId);
        if (userHomework) {
            userHomework.status = 1;
            userHomework.unreviewedUnitCount = 0;
        }
    }
    return {
        ...state,
        userHomeworks,
    };
};

const fixHomeworkPostReducer = (state, { data, vo }) => {
    return {
        ...state,
    };
};

const fixHomeworkZipPostReducer = (state, { data, vo }) => {
    return {
        ...state,
    };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_USERHOMEWORK_STATISTICS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_USERHOMEWORK_STATISTICS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_USERHOMEWORK_STATISTICS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.RETURN_USER_HOMEWORK_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.RETURN_USER_HOMEWORK_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.RETURN_USER_HOMEWORK_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.FIX_HOMEWORK_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.FIX_HOMEWORK_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.FIX_HOMEWORK_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.FIX_HOMEWORK_ZIP_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.FIX_HOMEWORK_ZIP_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.FIX_HOMEWORK_ZIP_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
